import { RefObject, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
// Models
import { IMyUser } from 'app/models/User';
import { ICurrentAccount } from 'app/models/Account';
import IInsuranceCase from 'app/models/Case';
import { IPrompt } from 'app/store/AIChatPrompts/AIChatPrompts.models';
// Redux
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Actions
import MixpanelActions from 'app/features/mixpanel/MixpanelActions';
// Selectors
import { selectMyUser } from 'app/store/Users/Users.selectors';
import { selectCurrentAccount } from 'app/store/Accounts/Accounts.selectors';
import { selectInsuranceCase } from 'app/store/Cases/Cases.selectors';
import { selectConversation } from 'app/store/AIChat/AIChat.selectors';
// Mui
import { Tooltip } from '@mui/material';
// Icons
import {
  AddCircleOutline as AddCircleOutlineIcon,
} from '@mui/icons-material';
// Components
import { IconButton } from 'app/components/Mui';
// Dialogs
import AIPromptSelectDialog from 'app/dialogs/AIPromptSelectDialog';
// Hooks
import useToggle from 'app/hooks/useToggle';

type Props = {
  disableControls: boolean;
}

export default function ChatMessagePromptButton({ disableControls }: Props){
  const { t } = useTranslation();

  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const myUser = useAppSelector(selectMyUser) as IMyUser;
  const currentAccount = useAppSelector(selectCurrentAccount) as ICurrentAccount;
  const insuranceCase = useAppSelector(selectInsuranceCase) as IInsuranceCase;
  const conversation = useAppSelector(selectConversation);

  const { setValue } = useFormContext();

  const { open, toggle } = useToggle();

  const handleConfirm = async (aiPrompt:IPrompt) => {
    const mixpanelData:any = {
      accountId: currentAccount.id,
      userId: myUser.id,
      caseId: insuranceCase.id,
      promptId: aiPrompt.id,
    };

    // setValue('question.promptId', aiPrompt.id);
    setValue('question.text', aiPrompt.content);

    if ( conversation ){
      mixpanelData['conversationId'] = conversation.id;
    }

    dispatch(MixpanelActions.handleAIChatPromptUse({ promptId: aiPrompt.id }));
  }

  return (
    <Fragment>
      <Tooltip title={t('buttons.promptHub')}>
        {/* Tooltip doesn`t work with disabled button, span added */}
        <span>
          <IconButton
            name="Prompt Hub"
            onClick={toggle}
            disabled={disableControls}
          ><AddCircleOutlineIcon /></IconButton>
        </span>
      </Tooltip>
      {open ? (
        <AIPromptSelectDialog
          open={open}
          onClose={toggle}
          onConfirm={handleConfirm}
        />
      ) : null}
    </Fragment>
  )
}
